const aceLinksCategories = [
    {
        name: "M. LaLiga",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/a489e81dbee19bcfceee8013165a38f6?withName=laligatv-por-movistar-plus-logo-png_seeklogo-490011.png",
        condition: {
            type: "or",
            condition: [
                {
                    text: "m. laliga",
                    type: "includes"
                }, {
                    text: "movistar laliga",
                    type: "includes"
                }
            ]
        }
    },
    {
        name: "DAZN LaLiga",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/0db9bd7d835c2b32927c9471b0c552a2?withName=dazn-laliga-logo-png_seeklogo-490009.png",
        condition: {
            type: "and",
            condition: [
                {
                    text: "dazn",
                    type: "includes"
                }, {
                    text: "laliga",
                    type: "includes"
                }
            ]
        }
    },
    {
        name: "DAZN F1",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/991b7a2b23c47601017bc71745a23f85?withName=formula-1-logo-png_seeklogo-316433.png",
        condition: {
            type: "and",
            condition: [
                {
                    text: "dazn",
                    type: "includes"
                }, {
                    text: "f1",
                    type: "includes"
                }
            ]
        }
    }, {
        name: "Liga Campeones",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/6c305655854e2b5e89f186af65a96d25?withName=liga-de-campeones-por-movistar-plus-logo-png_seeklogo-492840.png",
        condition: {
            type: "or",
            condition: [
                {
                    text: "campeones",
                    type: "includes"
                }, {
                    text: "champions",
                    type: "includes"
                }
            ]
        }
    }, {
        name: "Deportes",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/95387951d7a557b8630ddabf3843cff6?withName=deportes-por-movistar-plus-logo-png_seeklogo-492841.png",
        condition: {
            text: "deporte",
            type: "includes"
        }
    }, {
        name: "Vamos",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/526d75e6cb318a965ec2c180a444ae13?withName=vamos-por-movistar-plus-logo-png_seeklogo-493709.png",
        condition: {
            text: "vamos",
            type: "includes"
        }
    }, {
        name: "DAZN",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/0a4baa80eacf16c06ab2ebdfb6701a66?withName=dazn-logo-png_seeklogo-399335.png",
        condition: {
            type: "and",
            condition: [
                {
                    text: "dazn",
                    type: "includes"
                }, {
                    text: "laliga",
                    type: "not_includes"
                }, {
                    text: "f1",
                    type: "not_includes"
                }
            ]
        }
    },
    {
        name: "LaLiga Hypermotion",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/63dc1ee9ed271feb32e0f278ec71f18f?withName=laliga-hypermotion-logo-png_seeklogo-490007.png",
        condition: {
            type: "or",
            condition: [
                {
                    text: "smartbank",
                    type: "includes"
                }, {
                    text: "hypermotion",
                    type: "includes"
                }
            ]
        }
    },
    {
        name: "Movistar+",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/e0c47b79e43742538b099def33530005?withName=movistar-plus-2022-logo-png_seeklogo-432602.png",
        default: true,
    },
    {
        name: "Eurosport",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/5cf66d557d16daada2b8647e5dc8e3de?withName=eurosport-logo-png_seeklogo-50293.png",
        condition: {
            text: "eurosport",
            type: "includes"
        }
    },
    {
        name: "Telecinco",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/dd9f081368b881a8034b522fb9e88866?withName=telecinco_circular_500_-1_bda1.png",
        condition: {
            text: "telecinco",
            type: "includes"
        }
    },
    {
        name: "Cuatro",
        icon: "https://torresowo.myftp.org/cap17drive/v2/files/81cab53c369068ef53b0d5a5603d6d60?withName=cuatro.jpg",
        condition: {
            text: "cuatro",
            type: "includes"
        }
    }
]

export default aceLinksCategories;
